import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AdminEnquiries() {
    const [items, setItems] = useState([]);
    const load = () => api.get("/admin/enquiries").then(({ data }) => setItems(data.enquiries));
    useEffect(() => { load(); }, []);

    const mark = async (id, status) => { await api.put(`/admin/enquiries/${id}/status`, { status }); toast.success("Updated"); load(); };

    return (
        <div>
            <h1 className="text-2xl font-semibold mb-6">Contact Enquiries</h1>
            {items.length === 0 ? <p className="text-gray-400 py-10 text-center">No enquiries.</p> : (
                <div className="space-y-4">
                    {items.map((e) => (
                        <div key={e.id} className="bg-white border border-gray-200 rounded-lg p-5">
                            <div className="flex justify-between items-start">
                                <div><p className="font-medium">{e.subject}</p><p className="text-xs text-gray-400">{e.name} · {e.email} · {e.phone || "no phone"} · {(e.created_at || "").slice(0, 10)}</p></div>
                                <span className={`text-xs px-2 py-1 rounded ${e.status === "new" ? "bg-yellow-100 text-yellow-700" : "bg-gray-100"}`}>{e.status}</span>
                            </div>
                            <p className="text-sm text-gray-600 mt-3">{e.message}</p>
                            <div className="flex gap-2 mt-3">
                                <a href={`mailto:${e.email}`} className="text-sm text-gold">Reply by email</a>
                                {e.status === "new" && <button onClick={() => mark(e.id, "resolved")} className="text-sm text-gray-500 ml-auto">Mark resolved</button>}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
